import * as rest from '../../services'
import * as ReactBootstrap from 'react-bootstrap'
import React from 'react'

export const RightToggleButton = ({ right, property, onChange }) => {
  const updateUserRight = () => {
    let memClone = { ...right }
    memClone[property] = !right[property]
    new rest.UserRightsService(right.url).makePutRequest(memClone)
    onChange()
  }

  return (
    <ReactBootstrap.Button
      style={{ padding: '0px', margin: '0px', textAlign: 'right' }}
      variant="link"
      className="btn text-dark"
      onClick={updateUserRight}
    >
      {right[property] ? 'Revoke' : 'Grant'}
    </ReactBootstrap.Button>
  )
}
